<script>
    export let id;
    export let text;
    export let type = "primary";
    export let status = "inactive";
    export let onClick;
</script>

<div class={`button ${type} ${status}`} on:click={() => onClick(id)}>
    {text}
</div>

<style>
    .button {
        border: 2px solid #333333;
        border-radius: 25px;
        color: #333333;
        cursor: pointer;
        margin-right: 8px;
        padding: 5px 20px;
    }
    .button:hover {
      background-color: #333333;
      color: #f4f4f4;
    }
    .button.active {
      background-color: #333333;
      color: #f4f4f4;
      cursor: default;
      pointer-events: none;
    }
    .button:last-child {
      margin-right: 0;
    }
</style>